import Button from '@zenbusiness/common-components/Button';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import SharedAsset from '#client/components/SharedAsset';
import { SCREEN_BY_ROUTE } from '#client/pages/Money/utils/constants';

import { Container } from './useStyles';

const variations = {
  first: {
    title: 'Get more Money Pro on the go',
    img: '/icon/misc/money-icon-coins-3.svg',
    content: [
      'Now you can create and send invoices from your phone or tablet!',
      'You can also track your business expenses in the app.',
      'We\'ll let you know when you can manually create or import expenses, track mileage, and view reports from your mobile device.'
    ]
  },
  second: {
    title: 'Track expenses in the app',
    img: '/icon/misc/money-icon-coins-3.svg',
    content: [
      'Now you can view and tag expenses in our app from your phone or tablet!',
      'We\'ll notify you when you can also create and import expenses, add rules, and get reports from the app.'
    ],
    button: {
      text: 'Get the app',
      url: 'https://apps.apple.com/US/app/id1588955434?mt=8'
    }
  }
};

const MobileMessage = ({
  page
}) => {
  const variation = page === SCREEN_BY_ROUTE.expenses ? variations.second : variations.first;
  const {
    title, img, content, button
  } = variation;

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap="1rem">
        <Title level={2} variant="medium" color="focus90">{title}</Title>
        <SharedAsset width={80} height={80} alt="coins" src={img} />
      </Box>
      <Box display="flex" flexDirection="column" gap="1rem">
        {content.map((line) => (
          <Text key={line} size="lg" color="focus90">{line}</Text>
        ))}
      </Box>
      {button && (
        <Button onClick={() => window.location.replace(button.url)}>{button.text}</Button>
      )}
    </Container>
  );
};

MobileMessage.propTypes = {
  page: PropTypes.string
};

export default MobileMessage;
